import { BrandColor } from '@styleseat/brand';
import { openExternalUrl } from '../../modules/openExternalUrl';
import type { AdminThemeProps } from './types';
import { STRIPE_JS_KEY } from '../../config';

export const DATE_FORMAT = 'M/D/YY h:mma';

export const handleExternalNavigationTo = (url: string) => () => {
  openExternalUrl(url, '_blank');
};

const isStripeTestMode = /test/.test(STRIPE_JS_KEY);

export const handleGoToStripeTransactionCallback = (stripeTransaction: string) => (
  handleExternalNavigationTo(
    `https://dashboard.stripe.com${isStripeTestMode ? '/test' : ''}/payments/${stripeTransaction}`,
  )
);

export const AdminTheme: AdminThemeProps = {
  PageBackgroundColor: BrandColor.BoneLight,
  PageTextColor: BrandColor.BackInBlack,

  SectionBackgroundColor: BrandColor.WhiteWash,
  SectionHeaderBackgroundColor: BrandColor.Metal,
  SectionHeaderTextColor: BrandColor.WhiteWash,

  TableHeaderBackgroundColor: BrandColor.Transparent,
  TableHeaderTextColor: BrandColor.Ash,
  TableHeaderFontWeight: 'bold',
  TableBorderColor: BrandColor.LightGrey,

  LinkColor: BrandColor.Blue,
  LinkFontWeight: 'bold',

  LabelColor: BrandColor.Metal,
  LabelFontWeight: 'bold',

  SuccessColor: BrandColor.Green,
  ErrorColor: BrandColor.Red,

  GridSpace: 16,
};
